<template>
    <div class="symbol-banner">
        <SymbolInfo :options="tickerOptions.chartOptions" />
    </div>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { SymbolInfo } from 'vue-tradingview-widgets'
import { useEntityStore } from '@/stores'
import { formatTicker } from '@/lib/financial'

const entityStore = useEntityStore()

const tickerOptions = reactive({
    chartOptions: {
        allow_symbol_change: true,
        symbol: formatTicker(entityStore.entity.stock_exchange, entityStore.entity.stock_ticker),
        autosize: true,
        width: '100%',
    },
})
</script>

<style lang="scss" scoped>
.symbol-banner {
    width: 100%;
}
</style>
